// const API_URL = "https://nxts.ir:9686"
const API_URL = process.env.REACT_APP_API_URL + "/api"
// const API_URL = "https://farats.ir:4512"

export { API_URL }

// Socket URL - convert HTTP to WebSocket
const SOCKET_URL =
    process.env.REACT_APP_SOCKET_URL ||
    (API_URL ? API_URL.replace(/^http/, "ws").replace("/api", "") : "ws://localhost:3001")

export const NEW_ROUTES = {
    SERVER: {},
}

export const API_ROUTES = {
    SERVER: {
        CREATE_SERVER: `${API_URL}/server/create`,
        EDIT_SERVER: `${API_URL}/server/edit`,

        ACTIVATE_SERVER: `${API_URL}/server/activate`,
        SUSPEND_SERVER: `${API_URL}/server/suspend`,
        DELETE_SERVER: `${API_URL}/server/delete`,

        START_SERVER: `${API_URL}/server/start`,
        START_SERVER_BULK: `${API_URL}/server/start-bulk`,
        STOP_SERVER: `${API_URL}/server/stop`,
        STOP_SERVER_BULK: `${API_URL}/server/stop-bulk`,
        RESTART_SERVER: `${API_URL}/server/restart`,
        RESTART_SERVER_BULK: `${API_URL}/server/restart-bulk`,

        EXTEND_SERVER: `${API_URL}/server/extend`,

        GET_SERVER_LIST: `${API_URL}/server/get-server-list`,
        GET_USED_PORTS: `${API_URL}/server/get-used-ports`,
        GET_SERVER: `${API_URL}/server/get-server`,
        SNAPSHOT: {
            CREATE: `${API_URL}/server/snapshot/create`,
            DEPLOY: `${API_URL}/server/snapshot/deploy`,
            DELETE: `${API_URL}/server/snapshot/delete`,
            GET_ALL: `${API_URL}/server/snapshot/getall`,
            DOWNLOAD: `${API_URL}/server/snapshot/download`,
        },
    },
    USER: {
        CREATE_USER: `${API_URL}/user/create`,
        EDIT_USER: `${API_URL}/user/edit`,
        FULL_SUSPEND_USER: `${API_URL}/user/full-suspend`,
        SUSPEND_USER: `${API_URL}/user/suspend`,
        FULL_ACTIVATE_USER: `${API_URL}/user/full-activate`,
        ACTIVATE_USER: `${API_URL}/user/activate`,
        DELETE_USER: `${API_URL}/user/delete`,
        CHANGE_USER_PASSWORD: `${API_URL}/user/change-user-password`,

        AUTHENTICATE: `${API_URL}/user/authenticate`,
        REFRESH_TOKEN: `${API_URL}/user/refresh-token`,
        GET_CREDENTIALS: `${API_URL}/user/get-credentials`,
        GET_ALL_USERS: `${API_URL}/user/get-user-list`,

        TOKEN: {
            CREATE: `${API_URL}/user/token/create`,
            DELETE: `${API_URL}/user/token/delete`,
            GET_TOKEN_LIST: `${API_URL}/user/token/get-token-list`,
        },
    },
    AUDIO_BOT: {
        ACTIVATE_BOT: `${API_URL}/audio-bot/activate`,
        CREATE_BOT: `${API_URL}/audio-bot/create`,
        CHANGE_PLAYING: `${API_URL}/audio-bot/change-playing`,
        EDIT_BOT: `${API_URL}/audio-bot/edit`,
        DELETE_BOT: `${API_URL}/audio-bot/delete`,
        EXTEND_BOT: `${API_URL}/audio-bot/extend`,
        RECONNECT_BOT: `${API_URL}/audio-bot/reconnect`,
        RECONNECT_BULK: `${API_URL}/audio-bot/reconnect-bulk`,
        CONNECT_BOT: `${API_URL}/audio-bot/connect`,
        CONNECT_BULK: `${API_URL}/audio-bot/connect-bulk`,
        DISCONNECT_BOT: `${API_URL}/audio-bot/disconnect`,
        DISCONNECT_BULK: `${API_URL}/audio-bot/disconnect-bulk`,
        SUSPEND_BOT: `${API_URL}/audio-bot/suspend`,
    },
    SETTINGS: {
        PACKAGES: {
            AUDIO_BOT: {
                CREATE: `${API_URL}/settings/packages/audiobot/create`,
                EDIT: `${API_URL}/settings/packages/audiobot/edit`,
                DELETE: `${API_URL}/settings/packages/audiobot/delete`,
                GET_ALL: `${API_URL}/settings/packages/audiobot/getAll`,
            },
            SERVER: {
                CREATE: `${API_URL}/settings/packages/server/create`,
                EDIT: `${API_URL}/settings/packages/server/edit`,
                DELETE: `${API_URL}/settings/packages/server/delete`,
                GET_ALL: `${API_URL}/settings/packages/server/getAll`,
            },
        },
        COMPANY: {
            CREATE: `${API_URL}/settings/company/create`,
            EDIT: `${API_URL}/settings/company/edit`,
            DELETE: `${API_URL}/settings/company/delete`,
            GET_ALL: `${API_URL}/settings/company/getAll`,
        },
        GLOBAL_MESSAGE: {
            SEND: `${API_URL}/settings/global-message/send`,
        },
        PANEL: {
            MANAGER: {
                CREATE: `${API_URL}/settings/panel/manager/create`,
                EDIT: `${API_URL}/settings/panel/manager/edit`,
                DELETE: `${API_URL}/settings/panel/manager/delete`,
                GET_ALL: `${API_URL}/settings/panel/manager/getAll`,
            },
            BANNER: {
                CREATE: `${API_URL}/settings/panel/banner/create`,
                EDIT: `${API_URL}/settings/panel/banner/edit`,
                DELETE: `${API_URL}/settings/panel/banner/delete`,
                GET_ALL: `${API_URL}/settings/panel/banner/getAll`,
            },
            AUDIO_BOT: {
                CREATE: `${API_URL}/settings/panel/audiobot/create`,
                EDIT: `${API_URL}/settings/panel/audiobot/edit`,
                DELETE: `${API_URL}/settings/panel/audiobot/delete`,
                GET_ALL: `${API_URL}/settings/panel/audiobot/getAll`,
            },
        },
        PERMISSIONS: {
            UPDATE: `${API_URL}/settings/permissions/update`,
            GET: `${API_URL}/settings/permissions/get`,
        },
        BANNER_DYNAMIC: {
            UPDATE: `${API_URL}/settings/banner-dynamic/update`,
            GET: `${API_URL}/settings/banner-dynamic/get`,
        },
        RADIO: {
            ADD: `${API_URL}/settings/radio/add`,
            EDIT: `${API_URL}/settings/radio/edit`,
            DELETE: `${API_URL}/settings/radio/delete`,
            GET_ALL: `${API_URL}/settings/radio/getAll`,
        },
        RANKSYSTEM_CONFIG: {
            UPDATE: `${API_URL}/settings/ranksystem-config/update`,
            GET: `${API_URL}/settings/ranksystem-config/get`,
        },
        CUSTOM_COMMANDS: {
            UPDATE: `${API_URL}/settings/custom-commands/update`,
            GET: `${API_URL}/settings/custom-commands/get`,
        },
        REFRESH_PANELS: `${API_URL}/settings/panel/refresh-panels`,
    },
    MANAGER_BOT: {
        ACTIVATE: `${API_URL}/manager-bot/activate`,
        CREATE: `${API_URL}/manager-bot/create`,
        EDIT: `${API_URL}/manager-bot/edit`,
        DELETE: `${API_URL}/manager-bot/delete`,
        EXTEND: `${API_URL}/manager-bot/extend`,
        RECONNECT: `${API_URL}/manager-bot/reconnect`,
        RECONNECT_BULK: `${API_URL}/manager-bot/reconnect-bulk`,
        CONNECT: `${API_URL}/manager-bot/connect`,
        CONNECT_BULK: `${API_URL}/manager-bot/connect-bulk`,
        DISCONNECT: `${API_URL}/manager-bot/disconnect`,
        DISCONNECT_BULK: `${API_URL}/manager-bot/disconnect-bulk`,
        SUSPEND: `${API_URL}/manager-bot/suspend`,
        FETCH_CONNECTION_DATA: `${API_URL}/manager-bot/fetch-connection-data`,
        TOGGLE_AUTORENEW: `${API_URL}/manager-bot/toggle-autorenew`,
        GET_LIST: `${API_URL}/manager-bot/get-bot-list`,
    },
    BANNER_BOT: {
        ACTIVATE: `${API_URL}/banner-bot/activate`,
        CREATE: `${API_URL}/banner-bot/create`,
        EDIT: `${API_URL}/banner-bot/edit`,
        DELETE: `${API_URL}/banner-bot/delete`,
        EXTEND: `${API_URL}/banner-bot/extend`,
        RECONNECT: `${API_URL}/banner-bot/reconnect`,
        RECONNECT_BULK: `${API_URL}/banner-bot/reconnect-bulk`,
        CONNECT: `${API_URL}/banner-bot/connect`,
        CONNECT_BULK: `${API_URL}/banner-bot/connect-bulk`,
        DISCONNECT: `${API_URL}/banner-bot/disconnect`,
        DISCONNECT_BULK: `${API_URL}/banner-bot/disconnect-bulk`,
        SUSPEND: `${API_URL}/banner-bot/suspend`,
        FETCH_CONNECTION_DATA: `${API_URL}/banner-bot/fetch-connection-data`,
        TOGGLE_AUTORENEW: `${API_URL}/banner-bot/toggle-autorenew`,
        GENERATE_TOKEN_FOR_BANNER_PANEL: `${API_URL}/banner-bot/generate-token-for-banner-panel`,
        GET_LIST: `${API_URL}/banner-bot/get-bot-list`,
        GET_DELETE_CALCULATION: `${API_URL}/banner-bot/get-delete-calculation`,
        GET_EXTEND_CALCULATION: `${API_URL}/banner-bot/get-extend-calculation`,
    },
    RANKSYSTEM: {
        ACTIVATE: `${API_URL}/ranksystem/activate`,
        CONNECT: `${API_URL}/ranksystem/connect`,
        CONNECT_BULK: `${API_URL}/ranksystem/connect-bulk`,
        CREATE: `${API_URL}/ranksystem/create`,
        DELETE: `${API_URL}/ranksystem/delete`,
        DISCONNECT: `${API_URL}/ranksystem/disconnect`,
        DISCONNECT_BULK: `${API_URL}/ranksystem/disconnect-bulk`,
        EDIT: `${API_URL}/ranksystem/edit`,
        EXTEND: `${API_URL}/ranksystem/extend`,
        GET_BOT_INFO: `${API_URL}/ranksystem/get-bot-info`,
        GET_LIST: `${API_URL}/ranksystem/get-bot-list`,
        RECONNECT: `${API_URL}/ranksystem/reconnect`,
        RECONNECT_BULK: `${API_URL}/ranksystem/reconnect-bulk`,

        SUSPEND: `${API_URL}/ranksystem/suspend`,
        UPDATE_SETTINGS: `${API_URL}/settings/ranksystem-config/update`,
        GET_SETTINGS: `${API_URL}/settings/ranksystem-config/get`,
    },
}

export const APP_ROUTES = {
    INDEX: "/",
    SETTINGS: "/settings",
    USERS: "/users",
    SIGN_IN: "/sign-in",
    MANAGE_SERVER: "/manage-server",
    TS_MANAGER_BOTS: "/ts-manager-bots",
    MUSIC_BOTS: "/music-bots",
    RANKSYSTEMS: "/ranksystems",
    BANNER_BOTS: "/banner-bots",
}

export { SOCKET_URL }

export const PRICES = [
    {
        en: "usdPrice",
        fa: "دلار",
    },
    {
        en: "eurPrice",
        fa: "یورو",
    },
    {
        en: "lirPrice",
        fa: "لیر ترکیه",
    },
    {
        en: "rublePrice",
        fa: "روبل روسیه",
    },
    {
        en: "dinarPrice",
        fa: "دینار",
    },
    {
        en: "btcPrice",
        fa: "بیتکوین",
    },
    {
        en: "ethPrice",
        fa: "اتریوم",
    },
    {
        en: "trxPrice",
        fa: "ترون",
    },
    {
        en: "xrpPrice",
        fa: "ریپل",
    },
    {
        en: "lcoinPrice",
        fa: "لایت کوین",
    },
]

export const CITYS = [
    {
        en: "tehran",
        fa: "تهران",
    },
    {
        en: "shiraz",
        fa: "شیراز",
    },
    {
        en: "tabriz",
        fa: "تبریز",
    },
    {
        en: "isfahan",
        fa: "اصفهان",
    },
    {
        en: "yazd",
        fa: "یزد",
    },
]
